import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { IonRouterOutlet } from '@ionic/angular'
import { AlarmAppInstallModalComponent } from 'src/app/common/modals/alarm-app-install-modal/alarm-app-install-modal.component'
import { Page } from 'src/app/core/page'
import { Notification, PushCode } from 'src/app/interfaces/notification'
import { GeneralService } from 'src/app/services/general/general.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { NotificationService } from 'src/app/services/notification/notification.service'
import { PushNavigationService } from 'src/app/services/notification/push-navigation.service'
import { RouterService } from 'src/app/services/router/router.service'
import { UserService } from '../../services/user/user.service'

@Component({
  selector: 'app-alarm',
  templateUrl: './alarm.component.html',
  styleUrls: ['./alarm.component.scss'],
})
export class AlarmComponent extends Page implements OnInit {
  screenName = 'alarm'
  unreadNotificationList: Notification[] = []
  readNotificationList: Notification[] = []
  pushCode = PushCode
  private latestReadNotificationId = 0
  private cursor: string | null = null
  private isLoading = false
  private onceContentLoaded = false

  constructor(
    public userService: UserService,
    protected generalService: GeneralService,
    protected routerService: RouterService,
    protected routerOutlet: IonRouterOutlet,
    protected modalService: ModalService,
    protected title: Title,
    protected logService: LogService,
    protected localeService: LocaleService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private notificationService: NotificationService,
    private pushNavigationService: PushNavigationService
  ) {
    super(generalService, routerService, routerOutlet, modalService, title, logService, localeService)
  }

  get isNotificationEmpty(): boolean {
    return this.onceContentLoaded && this.unreadNotificationList.length === 0 && this.readNotificationList.length === 0
  }

  ngOnInit(): void {
    this.setTitle('알림')
    // 다른 페이지로 이동했다가 뒤로 돌아올 경우는 안읽음 메세지가 업데이트 되면 안되고, 새로 진입할 경우에만 업데이트 되어있어야 한다.
    // 그렇기에 서비스의 데이터 사용하지 않고 최초에만 assign 후 stateless하게 가지고 있음.
    if (this.latestReadNotificationId === 0) {
      this.latestReadNotificationId = this.notificationService.latestReadNotificationId
    }
    this.getNotificationList()
  }

  getNotificationList(): void {
    if ((this.unreadNotificationList.length > 0 || this.readNotificationList.length > 0) && this.cursor === null) {
      return
    }
    this.isLoading = true
    this.notificationService.getNotificationList(this.cursor).subscribe(
      (res) => {
        this.isLoading = false
        const data = res.data ?? []
        const notificationList: Notification[] = data.map((noti) => {
          return {
            ...noti,
            inAppContent: this.notificationService.parseContent(noti),
          }
        })
        this.cursor = res.cursor ?? null

        // 로컬 데이터보다 최신의 알림이 있다면 최신 id 갱신
        if (notificationList.length > 0 && notificationList[0].id > this.notificationService.latestReadNotificationId) {
          this.notificationService.latestReadNotificationId = notificationList[0].id
        }
        notificationList.forEach((noti) => {
          if (noti.id > this.latestReadNotificationId) {
            this.unreadNotificationList.push(noti)
          } else {
            this.readNotificationList.push(noti)
          }
        })
        this.onceContentLoaded = true
      },
      (error) => {
        this.isLoading = false
        this.onceContentLoaded = true
      }
    )
  }

  onClickAlarm(item: Notification, index: number): void {
    const alarm: HTMLElement = this.elementRef.nativeElement.querySelector(`.alarm-${index}`)
    if (alarm !== undefined) {
      this.renderer.addClass(alarm, 'read')
    }
    this.alarmAction(item)
  }

  onScrollEvent($event): void {
    if (this.isLoading) {
      return
    }
    const ionContent = this.elementRef.nativeElement.querySelector('ion-content')
    const scrollY = $event.detail.scrollTop
    if (scrollY + window.innerHeight > ionContent.scrollHeight - 300) {
      this.getNotificationList()
    }
  }

  /** 알림 클릭 시 로깅 */
  private async alarmAction(item: Notification): Promise<void> {
    // hsp관련 알림은 앱 인스톨 모달 띄워줌
    if (item.code.includes('HSP_')) {
      const modalData = {
        title: '타입스 앱을 설치해주세요',
        description: '타입스 앱을 설치하고 타입스의 모든 기능을 이용해 보세요',
        buttonText: '타입스 앱 설치하기',
      }
      const dialog = await this.modalService.openDialog(
        AlarmAppInstallModalComponent,
        modalData,
        'custom-center-round-modal'
      )
      await dialog.present()
      return
    }
    this.pushNavigationService.handlePushNotification(item)
    this.alarmClickLogging(item)
  }

  /** 알림 클릭 로깅 */
  private alarmClickLogging(item: Notification): void {
    this.pushNavigationService.notificationClickLog(item)
  }
}
